import { KIZEN_PREFIX, SessionStorage } from 'storage/Storage';
import { isValidKiCodeTarget, type KiCodeTarget } from '../profiles';

export interface KiCodeResume {
  target: KiCodeTarget;
  conversationId: string;
}

// Parsed JSON from session storage: untrusted until checked field by field.
const storage = new SessionStorage<unknown>(`${KIZEN_PREFIX}kicode-session`);

export const saveKiCodeResume = (
  identity: string | null,
  resume: KiCodeResume
) => {
  storage.val = { identity, ...resume };
};

export const loadKiCodeResume = (
  identity: string | null
): KiCodeResume | null => {
  const stored = storage.val;
  if (
    typeof stored !== 'object' ||
    stored === null ||
    !('identity' in stored) ||
    stored.identity !== identity
  ) {
    return null;
  }
  const { target, conversationId } = stored as Record<string, unknown>;
  if (
    !isValidKiCodeTarget(target) ||
    typeof conversationId !== 'string' ||
    conversationId === ''
  ) {
    return null;
  }
  return { target, conversationId };
};

export const clearKiCodeResume = () => storage.clear();
